module.exports = __webpack_public_path__ + "img/banner-font.0a9ad675.png";